/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";

import auth from "./auth.module";
import htmlClass from "./htmlclass.module";
import config from "./config.module";
import breadcrumbs from "./breadcrumbs.module";
import profile from "./profile.module";

import requestconfig from "./config/requestconfig.module";
//Modulos admin
import institucion from "./institucion.module";
import usuario from "./usuarios/usuario.module";
import usuarioadministrador from "./usuarios/usuarioadministrador.module";

import usuarioinstitucional from "./usuarios/usuarioinstitucional.module";
import usuarioinformador from "./usuarios/usuarioinformador.module";
import creadordepartamental from "./usuarios/creadordepartamental.module";
import empresa from "./empresa.module";
import socioextranjero from "./socioextranjero.module";

//Catalogos
import indice from "./catalogos/indice.module";

import asesorresponsable from "./asesorresponsable.module";
import region from "./region.module";
import departamento from "./catalogos/departamento.module";
import municipio from "./catalogos/municipio.module";
import lista from "./catalogos/listas/lista.module";
import opcionlista from "./catalogos/listas/opcionlista.module";
import puesto from "./puesto.module";
import rol from "./rol.module";
import tiposempresa from "./tiposempresa.module";
import oficinaceo from "./oficinaceo.module";
import tiposocio from "./tiposocio.module";
import subtiposocio from "./subtiposocio.module";
import tipodocumento from "./tipodocumento.module";
import cargaarchivo from "./cargaarchivo.module";
import contacto from "./contacto.module";
import componente from "./componente.module";
//Catalogos
import periodomedicion from "./catalogos/periodomedicion.module";
//Actualiza el estado de cualquier (Empresa, Institucion, Socio Extranjero)
import estadoitem from "./estadoitem.module";

//!Administracion de preguntas, sub preguntas y respuestas
import pregunta from "./pregunta.module";
import subpregunta from "./preguntas/subpregunta.module";

import respuesta from "./preguntas/respuestas/respuesta.module";
import tipodato from "./preguntas/respuestas/tiposdato/tipodato.module";
import tipoelemento from "./preguntas/respuestas/tiposelemento/tipoelemento.module.js";
import validacion from "./preguntas/validaciones/validacion.module";
import medioverificacion from "./preguntas/mediosverificacion/medioverificacion.module";


import boleta from "./boletas/boleta.module";
import boletamuni from "./boletas/boletamuni.module";
import aperturacierreboleta from "./boletas/aperturacierreboleta.module";

import respuestamuni from "./respuestasmuni/respuestamuni.module";
import medioverificacionmuni from "./respuestasmuni/medioverificacionmuni.module";


import preguntaperiodoboleta from "./preguntasperiodoboleta/preguntaperiodoboleta.module";





import revisionaprobacion from "./revisionaprobacion/revisionaprobacion.module";

import visitacampo from "./visitacampo/visitacampo.module";


import camposresultados from "./camposresultados/camposresultados.module";
import camposmuniperiodo from "./camposresultados/camposmuniperiodo.module";

import resultados from "./resultados/resultados.module";
//Compliant
import compliant from "./compliant.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    htmlClass,
    config,
    breadcrumbs,
    profile,
    institucion,
    usuario,
    usuarioadministrador,
    usuarioinstitucional,
    usuarioinformador,
    creadordepartamental,
    empresa,
    socioextranjero,
    asesorresponsable,
    region,
    departamento,
    municipio,
    lista,
    opcionlista,
    puesto,
    indice,
    rol,
    periodomedicion,
    tiposempresa,
    oficinaceo,
    tiposocio,
    subtiposocio,
    tipodocumento,
    cargaarchivo,
    contacto,
    estadoitem,
    pregunta,
    subpregunta,
    respuesta,
    tipodato,
    tipoelemento,
    validacion,
    medioverificacion,
    boleta,
    boletamuni,
    aperturacierreboleta,
    respuestamuni,
    medioverificacionmuni,

    
    preguntaperiodoboleta,
    subpregunta,


    revisionaprobacion,
    visitacampo,
    camposresultados,
    camposmuniperiodo,
    resultados,

    compliant,
    componente
  }
});
